import { InfoTooltip } from "@/lib/dashboard/InfoTooltip";

interface OverviewCardRowProps {
  label: string;
  value: string;
  info?: string;
  /** Pallino colorato davanti all'etichetta, per le righe che sono quote di un totale. */
  dotClassName?: string;
  /** Riga di chiusura: valore in nero e in grassetto, il resto resta grigio. */
  strong?: boolean;
}

/**
 * Riga etichetta / valore delle card della Panoramica.
 *
 * Le tre card in cima portano liste di numeri, non un numero solo: senza un allineamento
 * comune ognuna avrebbe finito per inventarsi la propria spaziatura, e affiancate si
 * sarebbe visto. `tabular-nums` tiene le cifre incolonnate anche fra righe diverse.
 */
export function OverviewCardRow({
  label,
  value,
  info,
  dotClassName,
  strong = false,
}: OverviewCardRowProps) {
  return (
    <div className="flex items-center justify-between gap-2 text-sm">
      <span className="inline-flex items-center gap-1.5 text-gray-600 min-w-0">
        {dotClassName && (
          <span className={`h-2 w-2 rounded-full flex-shrink-0 ${dotClassName}`} />
        )}
        <span className="truncate">{label}</span>
        {info && <InfoTooltip text={info} />}
      </span>
      <span
        className={`tabular-nums flex-shrink-0 ${
          strong ? "font-semibold text-gray-900" : "font-medium text-gray-700"
        }`}
      >
        {value}
      </span>
    </div>
  );
}

export default OverviewCardRow;
